/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { ProductoInterface } from '../interfaces/productos.interface';
import { GetTodosResponse } from '../interfaces/http_responses.intercace';

import { environment } from '../../environments/environment';
import { AlertController, ToastController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UsuarioService } from './usuario.service';

@Injectable({
  providedIn: 'root',
})
export class ProductosService {


  
  pagina = 0;
  paginaCategorias = 0;

  paginaOfertas = 0;
  en_Oferta: any[] = [];

  productos: any[] = [];
  categorias: any[] = [];
  por_Categoria: any[] = [];

  resultado_busqueda: ProductoInterface[] = [];
  Existencias: any[] = [];

  constructor(private http: HttpClient,
              private alertCtrl: AlertController,
              private toastCtrl: ToastController,
              private translate: TranslateService) {
    
    
    // this.cargar_todos('0');
    this.cargar_categorias();
  }

  cargar_porCategorias(categoria2Get: string) {
    const promesaCat = new Promise((resolve, reject) => {
      const url =
        environment.urlServicios +
        '/productos/por_tipo/' +
        categoria2Get +
        '/' +
        this.paginaCategorias;

      this.http.get(url).pipe(take(1)).subscribe(async (data: any) => {
        if (data.error) {

          const alerta = await this.alertCtrl.create({
            header: this.translate.instant('ERRORS.ERROR_CARGANDO_CATEGORIAS'),
            message: data.mensaje,
            buttons: ['OK']
          });
          await alerta.present();


        } else {
          if (data.Productos.length > 0) {
            this.por_Categoria.push(...data.Productos);
            this.paginaCategorias += 1;
          }
        }
        resolve(true);
      });
    });

    return promesaCat;
  }

  cargar_enOferta() {
    const promesaOfertas = new Promise((resolve, reject) => {
      const url =
        environment.urlServicios +
        '/productos/en_oferta/' + this.paginaOfertas;

      this.http.get(url).pipe(take(1)).subscribe(async (data: any) => {
        if (data.error) {
          const alerta = await this.alertCtrl.create({
            header: this.translate.instant('ERRORS.ERROR_CARGANDO_OFERTAS'),
            message: data.mensaje,
            buttons: ['OK']
          });
          await alerta.present();


        } else {
          if (data.Productos.length > 0) {
            this.en_Oferta.push(...data.Productos);
            this.paginaOfertas += 1;
          }
        }
        resolve(true);
      });
    });

    return promesaOfertas;
  }

  cargar_categorias() {
    const url = environment.urlServicios + '/categorias';

    this.http.get(url).pipe(take(1)).subscribe(async (data: any) => {
      if (data.error) {
          const alerta = await this.alertCtrl.create({
            header: this.translate.instant('ERRORS.ERROR_CARGANDO_ORDENES'),
            message: data.mensaje,
            buttons: ['OK']
          });
          await alerta.present();
      } else {
        this.categorias = data.Categorias;
      }
    }, async error => {

      const mensaje = error.name === 'HttpErrorResponse' ? this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA') : error.message;
      const alerta = await this.alertCtrl.create({
        header: 'Error!!',
        message: mensaje,
        buttons: ['OK']
      });
      await alerta.present();
    });
  }

  cargar_todos(idUsuario: string) {
    const promesa = new Promise((resolve, reject) => {
      
      const url = environment.urlServicios + '/productos/todos/' + this.pagina + '/' + idUsuario; 
      
      this.http.get<GetTodosResponse>(url)
      .pipe(take(1)).subscribe(
        async (data: any) => {
          
          if (data.error) {
            const tc = await this.toastCtrl.create({
              header: this.translate.instant('ERRORS.ERROR_CARGANDO_PRODUCTOS'),
              message: data.mensaje,
              color: 'danger',
              duration: 1000,
              buttons: ['OK']
            });
            await tc.present();
            reject();

          } else {
            
            if (data.Productos.length > 0) {

              const tc = await this.toastCtrl.create({
                message: this.translate.instant('CARGANDO'),
                duration: 1,
                icon: 'globe',
                animated: true
              });
              await tc.present();

              const nuevaData = this.agrupar(data.Productos, 2);
              this.productos.push(...nuevaData);
              
              this.pagina += 1;
            }
          }
          resolve(true);
        }, async (error) => {

          resolve(false);
          const mensaje = error instanceof HttpErrorResponse ? this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA') : error.message;

          const tc = await this.toastCtrl.create({
            message: mensaje,
            duration: 1500,
            color: 'danger',
            icon: 'globe',
          });
          await tc.present();
        });
    });

    return promesa;
  }

  private agrupar(arr: any, tamano: number) {
    const nuevoArreglo = [];
    for (let i = 0; i < arr.length; i += tamano) {
      nuevoArreglo.push(arr.slice(i, i + tamano));
    }
    return nuevoArreglo;
  }

  private desagrupar(arr: any[]) {
    return arr.flat();
  }

  
  buscar_producto(termino: string) {

    if (termino === '') {
      this.resultado_busqueda = [];
      return;
    }

    const url = environment.urlServicios + '/productos/buscar/' + termino;
    this.http.get(url).pipe(take(1)).subscribe((resp: any) => {
      this.resultado_busqueda = resp.Productos;
    }, async error => {
      const mensaje = error.name === 'HttpErrorResponse' ? this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA') : error.message;
      const alerta = await this.alertCtrl.create({
        header: this.translate.instant('ERRORS.ERROR_CARGANDO_PRODUCTOS'),
        message: mensaje,
        buttons: ['OK']
      });
      await alerta.present();
    });
  }

  getproducto_por_codigo(strCodigo: string) {
    const url = environment.urlServicios + '/productos/obtener_producto/' + strCodigo;
    return this.http.get(url);
  }

  cargar_existencias_por_almacen(idProducto: number) {
    const url =
      environment.urlServicios +
      '/productos/obtener_existencia_por_almacen/' +
      idProducto;
    this.http.get(url).pipe(take(1)).subscribe((resp: any) => {
      if (resp.error) {
      } else {
        this.Existencias = resp.existencia;
      }
    }, async error => {
      const mensaje = error.name === 'HttpErrorResponse' ? this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA') : error.message;
      const alerta = await this.alertCtrl.create({
        header: 'Error!!',
        message: mensaje,
        buttons: ['OK']
      });
      await alerta.present();
    });
  }

  existencia_total(idProducto: number) {
    const url =
      environment.urlServicios + '/productos/obtener_existencia/' + idProducto;
    this.http.get(url).pipe(take(1)).subscribe((resp: any) => {
      if (resp.error) {
      } else {
        return resp.existencia;
      }
    }, async error => {
      const mensaje = error.name === 'HttpErrorResponse' ? this.translate.instant('ERRORS.CONEXION_A_RED_FALLIDA') : error.message;
      const alerta = await this.alertCtrl.create({
        header: 'Error!!',
        message: mensaje,
        buttons: ['OK']
      });
      await alerta.present();
    });
  }

  public obtenerProductosAgrupados(arr: any[]) {
    return [...this.desagrupar(arr)];
  }

  async guardarLike(idProducto: string, idUsuario: string) {
    // Implementa aquí la lógica para guardar el like
    // Por ejemplo, hacer una llamada HTTP a tu backend
    const url = environment.urlServicios + '/productos/likes';

      
    return await this.http.post(url, {
      idProducto,
      idUsuario
    }).toPromise();


    // return await this.http.post(`${url}/${productoId}`, {}).toPromise();
  }


  obtenerPrecioPorPosicionNeto(producto: any, posicion: string ): number {
    switch (posicion) {
      case 'PRECIO A':
        return producto.dblPrecio;
      case 'PRECIO B':
        return producto.dblPrecioB;
      case 'PRECIO C':
        return producto.dblPrecioC;
      case 'PRECIO D':
        return producto.dblPrecioD;
    }
  }


  obtenerPrecioPorPosicion(producto: any, posicion: string ): number {
    // si el precio es en zona de oportunidades, ignorar el descuento de usuario
    if (producto.bolZonaOportunidades){
      return producto.dblPrecioD || 0;
    } else {
      switch (posicion) {
        case 'PRECIO A':
          return producto.dblPrecio;
        case 'PRECIO B':
          return producto.dblPrecioB;
        case 'PRECIO C':
          return producto.dblPrecioC;
        case 'PRECIO D':
          return producto.dblPrecioD;
      }
    }
  }

}
